import React from "react";
import { Fade } from "react-awesome-reveal";
import { useMediaQuery } from "react-responsive";
import "../styles/PorqueElegirnos.scss";

import id1 from "../images/identificadores/1.svg";
import id2 from "../images/identificadores/2.svg";
import id3 from "../images/identificadores/3.svg";
import id4 from "../images/identificadores/4.svg";
import id5 from "../images/identificadores/5.svg";

const PorqueElegirnos = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const velFade = 1200;

  const tarjetas = [
    {
      id: 1,
      imagen: id1,
      titulo: "8 años de experiencia",
      texto:
        "Chef profesional, operación probada y atención a detalle para eventos residenciales y empresariales.",
    },
    {
      id: 2,
      imagen: id2,
      titulo: "Sabor premium al carbón",
      texto:
        "Cortes, tacos, hamburguesas y más, con técnica al carbón que se nota en cada bocado.",
    },
    {
      id: 3,
      imagen: id3,
      titulo: "Montaje y vajilla incluidos",
      texto:
        "Llevamos mesas de montaje, mantel negro y vajilla (opción premium según disponibilidad).",
    },
    {
      id: 4,
      imagen: id4,
      titulo: "Servicio puntual y sin estrés",
      texto:
        "Nos encargamos del servicio para que tú disfrutes: montaje, atención y ejecución sin complicaciones.",
    },
    {
      id: 5,
      imagen: id5,
      titulo: "Beneficios y extras",
      texto:
        "Descuento por apartado en 72 hrs y postre al carbón (plátano macho + salsa a elegir).",
    },
  ];

  return (
    <section className="pxb-why" id="porqueE" aria-label="Por qué elegir Pixbae Banquetes">
      <div className="pxb-why__container">
        <Fade triggerOnce>
          <h3 className="pxb-why__title">
            ¿Por qué elegir <span>Pixbae Banquetes</span>?
          </h3>
        </Fade>

        <p className="pxb-why__subtitle">
          Servicio premium para eventos en <b>Guadalajara, Zapopan y Tlajomulco de Zúñiga</b>.
        </p>

        <div className="pxb-why__grid">
          {tarjetas.map((t) => (
            <article key={t.id} className="pxb-card">
              {isMobile ? (
                <Fade duration={velFade} triggerOnce>
                  <div className="pxb-card__icon">
                    <img src={t.imagen} alt={t.titulo} loading="lazy" />
                  </div>
                  <h4 className="pxb-card__title">{t.titulo}</h4>
                  <p className="pxb-card__text">{t.texto}</p>
                </Fade>
              ) : (
                <>
                  <div className="pxb-card__icon">
                    <img src={t.imagen} alt={t.titulo} loading="lazy" />
                  </div>
                  <h4 className="pxb-card__title">{t.titulo}</h4>
                  <p className="pxb-card__text">{t.texto}</p>
                </>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PorqueElegirnos;
